(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

var productSwatches = function productSwatches(){
  $(".product_box ul.color_list li input").click(function(){
    $(".product_box").removeClass("active_product");
    $(this).parents(".product_box").addClass("active_product");
    var radioValue = $(".product_box.active_product ul.color_list li input:checked+label").attr("data-value");
    if(radioValue){
      $(".product_box.active_product .product_img img").attr("src", radioValue); 
    }
  });
  var max = 3;
  $('.product_box ul.color_list').each(function(){
    $(this).find('li').each(function(index){
      if(index >= max) $(this).hide()
    })
  })
}
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#infinite_pagination',
    callback: productSwatches
  });
});
$(document).ready(function(){
  $(".filter_toggle").on("click", function(){
    $(".products_sidebar").addClass("show");
    $(".black_overlay").css("display", "block");
    $("html, body").css("overflow", "hidden");
  });
  $(".sidebar_close_icon, .black_overlay").on("click", function(){
    $(".products_sidebar").removeClass("show");
    $(".black_overlay").css("display", "none");
    $("html, body").css("overflow", "initial");
  });
});
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-full-backup"]) return;
  try {
    



  
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

$("[data-toggle=popover]").each(function(i, obj) {

$(this).popover({
  html: true,
});

});
  
   $(document).ready(function(){
    $(document).on("click", "fieldset.frame_colors input", function(){
        var radioValue = $("input[name='Select Frame Color']:checked").val();
        if(radioValue){
           $("fieldset.frame_colors .form__label .selected_value").text(radioValue); 
        }
    });
    $(document).on("click", "fieldset.lens_tint input", function(){
          var radioValue = $("input[name='Select A Lens Tint']:checked").val();
          if(radioValue){
             $("fieldset.lens_tint .form__label .selected_value").text(radioValue); 
          }
      });
    
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Lens Power']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
    });
  
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Prescription Lens']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Product Type']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-full"]) return;
  try {
    



  
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

$("[data-toggle=popover]").each(function(i, obj) {

$(this).popover({
  html: true,
});

});
  
   $(document).ready(function(){
    $(document).on("click", "fieldset.frame_colors input", function(){
        var radioValue = $("input[name='Select Frame Color']:checked").val();
        if(radioValue){
           $("fieldset.frame_colors .form__label .selected_value").text(radioValue); 
        }
    });
    $(document).on("click", "fieldset.lens_tint input", function(){
          var radioValue = $("input[name='Select A Lens Tint']:checked").val();
          if(radioValue){
             $("fieldset.lens_tint .form__label .selected_value").text(radioValue); 
          }
      });
    
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Lens Power']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
    });
  
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Prescription Lens']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Product Type']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-stickyBtn"]) return;
  try {
    
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

$("[data-toggle=popover]").each(function(i, obj) {

$(this).popover({
  html: true,
});

});
  
   $(document).ready(function(){
    $(document).on("click", "fieldset.frame_colors input", function(){
        var radioValue = $("input[name='Select Frame Color']:checked").val();
        if(radioValue){
           $("fieldset.frame_colors .form__label .selected_value").text(radioValue); 
        }
    });
    $(document).on("click", "fieldset.lens_tint input", function(){
          var radioValue = $("input[name='Select A Lens Tint']:checked").val();
          if(radioValue){
             $("fieldset.lens_tint .form__label .selected_value").text(radioValue); 
          }
      });
    
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Lens Power']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
    });
  
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Prescription Lens']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Product Type']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });


    var addToCartBtn = document.querySelector('.product-form__submit');
    
    var section = document.querySelector('.product_description');
    
    var sectionOffsetTop = section.offsetTop;
    
    window.addEventListener('scroll', function() {
        if (window.pageYOffset >= sectionOffsetTop) {
            addToCartBtn.classList.add('sticky');
        } else {
            addToCartBtn.classList.remove('sticky');
        }
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-titlePriceTop"]) return;
  try {
    
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

$("[data-toggle=popover]").each(function(i, obj) {

$(this).popover({
  html: true,
});

});
  
   $(document).ready(function(){
    $(document).on("click", "fieldset.frame_colors input", function(){
        var radioValue = $("input[name='Select Frame Color']:checked").val();
        if(radioValue){
           $("fieldset.frame_colors .form__label .selected_value").text(radioValue); 
        }
    });
    $(document).on("click", "fieldset.lens_tint input", function(){
          var radioValue = $("input[name='Select A Lens Tint']:checked").val();
          if(radioValue){
             $("fieldset.lens_tint .form__label .selected_value").text(radioValue); 
          }
      });
    
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Lens Power']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
    });
  
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Prescription Lens']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-titleTop"]) return;
  try {
    
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

$("[data-toggle=popover]").each(function(i, obj) {

$(this).popover({
  html: true,
});

});
  
   $(document).ready(function(){
    $(document).on("click", "fieldset.frame_colors input", function(){
        var radioValue = $("input[name='Select Frame Color']:checked").val();
        if(radioValue){
           $("fieldset.frame_colors .form__label .selected_value").text(radioValue); 
        }
    });
    $(document).on("click", "fieldset.lens_tint input", function(){
          var radioValue = $("input[name='Select A Lens Tint']:checked").val();
          if(radioValue){
             $("fieldset.lens_tint .form__label .selected_value").text(radioValue); 
          }
      });
    
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Lens Power']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
    });
  
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Prescription Lens']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Product Type']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    



  
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

$("[data-toggle=popover]").each(function(i, obj) {

$(this).popover({
  html: true,
});

});
  
   $(document).ready(function(){
    $(document).on("click", "fieldset.frame_colors input", function(){
        var radioValue = $("input[name='Select Frame Color']:checked").val();
        if(radioValue){
           $("fieldset.frame_colors .form__label .selected_value").text(radioValue); 
        }
    });
    $(document).on("click", "fieldset.lens_tint input", function(){
          var radioValue = $("input[name='Select A Lens Tint']:checked").val();
          if(radioValue){
             $("fieldset.lens_tint .form__label .selected_value").text(radioValue); 
          }
      });
    
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Lens Power']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
    });
  
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Prescription Lens']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Product Type']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product2"]) return;
  try {
    
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

$("[data-toggle=popover]").each(function(i, obj) {

$(this).popover({
  html: true,
});

});
   $(document).ready(function(){
    $(document).on("click", "fieldset.frame_colors input", function(){
        var radioValue = $("input[name='Select Frame Color']:checked").val();
        if(radioValue){
           $("fieldset.frame_colors .form__label .selected_value").text(radioValue); 
        }
    });
    $(document).on("click", "fieldset.lens_tint input", function(){
          var radioValue = $("input[name='Select A Lens Tint']:checked").val();
          if(radioValue){
             $("fieldset.lens_tint .form__label .selected_value").text(radioValue); 
          }
      });
    $(document).on("click", "fieldset.lens_tint input", function(){
          var radioValue = $("input[name='Select A Lens Tint Bundle']:checked").val();
          if(radioValue){
             $("fieldset.lens_tint .form__label .selected_value").text(radioValue); 
          }
      });
    
    $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Lens Power']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
    });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    

var productSwatches = function productSwatches(){
  $(".product_box ul.color_list li input").click(function(){
    $(".product_box").removeClass("active_product");
    $(this).parents(".product_box").addClass("active_product");
    var radioValue = $(".product_box.active_product ul.color_list li input:checked+label").attr("data-value");
    if(radioValue){
      $(".product_box.active_product .product_img img").attr("src", radioValue); 
    }
  });
  var max = 3;
  $('.product_box ul.color_list').each(function(){
    $(this).find('li').each(function(index){
      if(index >= max) $(this).hide()
    })
  })
}
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#infinite_pagination',
    callback: productSwatches
  });
});
$(document).ready(function(){
  $(".filter_toggle").on("click", function(){
    $(".products_sidebar").addClass("show");
    $(".black_overlay").css("display", "block");
  });
  $(".sidebar_close_icon, .black_overlay").on("click", function(){
    $(".products_sidebar").removeClass("show");
    $(".black_overlay").css("display", "none");
  });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-shippingtext-under-btn"]) return;
  try {
    



  
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

$("[data-toggle=popover]").each(function(i, obj) {

$(this).popover({
  html: true,
});

});
  
   $(document).ready(function(){
    $(document).on("click", "fieldset.frame_colors input", function(){
        var radioValue = $("input[name='Select Frame Color']:checked").val();
        if(radioValue){
           $("fieldset.frame_colors .form__label .selected_value").text(radioValue); 
        }
    });
    $(document).on("click", "fieldset.lens_tint input", function(){
          var radioValue = $("input[name='Select A Lens Tint']:checked").val();
          if(radioValue){
             $("fieldset.lens_tint .form__label .selected_value").text(radioValue); 
          }
      });
    
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Lens Power']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
    });
  
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Select Prescription Lens']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });
      $(document).on("click", "fieldset.lens_power input", function(){
          var radioValue = $("input[name='Product Type']:checked").val();
          if(radioValue){
             $("fieldset.lens_power .form__label .selected_value").text(radioValue); 
          }
      });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
$('#pdp_reviews_slider').owlCarousel({
	items: 1,
	loop:true,
	margin:0,
	nav:true,
	dots:true,
	autoplay: true,
	autoplayTimeout:6000,
	smartSpeed:800,
	navText:["<i class='fas fa-angle-left'></i>","<i class='fas fa-angle-right'></i>"],
    responsiveClass:true,
    responsive:{
      300:{
        items:1,
        stagePadding:45
      },
      768:{
        items:2,
        stagePadding:0
      },
      992:{
        items:4
      }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopping-questions-backup"]) return;
  try {
    
$(document).ready(function(){
  
  function updateHref() {
      var values = [];
      $('.phaseOne input[type="radio"]:checked').each(function() {
          var value = $(this).val();
          value = value.replace(/\s+/g, '+');
          values.push(value);
      });
      var href = 'https://gunnar.com/collections/shop-all?' + values.join('&');
  
        $('#dynamicLink').attr('href', href);
      $(".toggle-button").click(function(){
        $(this).css("opacity", "0.85");
        $(".loading-overlay__spinner").show();
        var hrefValue = $("#dynamicLink").attr("href");
        $.get(hrefValue, function(data) {
        var divData = $(data).find("div.product_count").html();
          
        $("#countProductQuestion").empty();
        setTimeout(function() { 
          $("#countProductQuestion").append(divData);
        }, 1000); 
        setTimeout(function() { 
          var sourceDivValue = $('#countProductQuestion').text();
          
          if(sourceDivValue.trim() > "0") {
              $('#targetDiv').hide();
              $(".hiddenBtns").show();
          }
          if(sourceDivValue.trim() < "1") {
              $('#targetDiv').show();
              $(".hiddenBtns").hide();
          }
        }, 1500);  

        setTimeout(function() { 
          $('.fifth_question').hide();
          $(".answer_box").show();
        }, 3000); 
      });
      console.log(divData)
});
  }
  $('.phaseOne input[type="radio"]').on('change', updateHref);

});
 

$(".prevFirst").click(function(){
  $(".first_question").show();
  var prevOption = $('input[name="use"]:checked').val();
  $('.toggle-button').attr('data-target', '#' + prevOption);
  $(".first_ans").hide();
  $(".second_question").hide();
});

$(".prevSecond").click(function(){
  $(".second_question").show();
  var prevOption = $('input[name="focus"]:checked').val();
  $('.toggle-button2').attr('data-target', '#' + prevOption);
});

$(".prevThird").click(function(){
  $(".second_question").show();
  var prevOption = $('input[name="focus2"]:checked').val();
  $('.toggle-button3').attr('data-target', '#' + prevOption);
  $(".third_question").hide();
});

$(".prevFourth").click(function(){
  $(".third_question").show();
  var prevOption = $('input[name="function"]:checked').val();
  $('.toggle-button4').attr('data-target', '#' + prevOption);
  $(".fourth_question").hide();
});

$(".prevFifth").click(function(){
  $(".fourth_question").show();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button5').attr('data-target', '#' + prevOption);
  $(".fifth_question").hide();
});

$(".prevSixth").click(function(){
  $(".fifth_question").show();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button6').attr('data-target', '#' + prevOption);
  $(".answer_box").hide();
  $(".sixth_question").hide();
  $(".loading-overlay__spinner").hide();
  $("#targetDiv").hide();
  $(".toggle-button").css("opacity", "1");
});

$(".prevSeventh").click(function(){
  $(".sixth_question").show();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button7').attr('data-target', '#' + prevOption);
  $(".seventh_question").hide();
});

$(".prevEight").click(function(){
  $(".seventh_question").show();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button8').attr('data-target', '#' + prevOption);
  $(".eight_question").hide();
});

$(".prevNinth").click(function(){
  $(".eight_question").show();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button9').attr('data-target', '#' + prevOption);
  $(".ninth_question").hide();
});

$(".prevTenth").click(function(){
  $(".ninth_question").show();
  $(".loading-overlay__spinner").hide();
  $(".second_ans").hide();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button10').attr('data-target', '#' + prevOption);
  $(".tenth_question").hide();
  $(".toggle-button2").css("opacity", "1");
});


$(".continueSecond").click(function(){
  $(".first_question").hide();
  $(".second_question").show();
});
$(".continueThird").click(function(){
  $(".second_question").hide();
  $(".third_question").show();
});

$(".continueFourth").click(function(){
  $(".third_question").hide();
  $(".fourth_question").show();
});

$(".continueFifth").click(function(){
  $(".fourth_question").hide();
  $(".fifth_question").show();
   $("#countProductQuestion").empty();
});

$(".continueSixth").click(function(){
  $(".fifth_question").hide();
  $(".sixth_question").show();
  $(".answer_box").hide();
  $(".loading-overlay__spinner").hide();
});

$(".continueSeventh").click(function(){
  $(".sixth_question").hide();
  $(".seventh_question").show();
});

$(".continueEight").click(function(){
  $(".seventh_question").hide();
  $(".eight_question").show();
});

$(".continueNinth").click(function(){
  $(".eight_question").hide();
  $(".ninth_question").show();
  $(".loading-overlay__spinner").hide();
});


$(document).ready(function(){
  
  function updateHref2() {
      var values = [];
      $('.phaseTwo input[type="radio"]:checked').each(function() {
          var value = $(this).val();
          value = value.replace(/\s+/g, '+');
          values.push(value);
      });
      var href2 = 'https://gunnar.com/collections/shop-all?' + values.join('&');
  
        $('#dynamicLink2').attr('href', href2);
      $(".toggle-button2").click(function(){
        
        $(this).css("opacity", "0.85");
        $(".loading-overlay__spinner").show();
        var hrefValue2 = $("#dynamicLink2").attr("href");
        $.get(hrefValue2, function(data) {
        var divData = $(data).find("div.product_count").html();
          
        $("#countProductQuestion2").empty();
        setTimeout(function() { 
          $("#countProductQuestion2").append(divData);
        }, 1000); 

         $("#countProductQuestion2").empty();
        setTimeout(function() { 
          $('.ninth_question').hide();
          $(".second_ans").show();
        }, 2500); 
      });
      console.log(divData)
});
  }
  $('.phaseTwo input[type="radio"]').on('change', updateHref2);

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopping-questions"]) return;
  try {
    
$(document).ready(function(){
  
  function updateHref() {
      var values = [];
      $('.phaseOne input[type="radio"]:checked').each(function() {
          var value = $(this).val();
          value = value.replace(/\s+/g, '+');
          values.push(value);
      });
      var href = 'https://gunnar.com/collections/shop-all?' + values.join('&');
  
        $('#dynamicLink').attr('href', href);
      $(".toggle-button").click(function(){
        $(this).css("opacity", "0.85");
        $(".loading-overlay__spinner").show();
        var hrefValue = $("#dynamicLink").attr("href");
        $.get(hrefValue, function(data) {
        var divData = $(data).find("div.product_count").html();
          
        $("#countProductQuestion").empty();
        setTimeout(function() { 
          $("#countProductQuestion").append(divData);
        }, 1000); 
        setTimeout(function() { 
          var sourceDivValue = $('#countProductQuestion').text();
          
          if(sourceDivValue.trim() > "0") {
              $('#targetDiv').hide();
              $(".hiddenBtns").show();
          }
          if(sourceDivValue.trim() < "1") {
              $('#targetDiv').show();
              $(".hiddenBtns").hide();
          }
        }, 1500);  

        setTimeout(function() { 
          $('.fifth_question').hide();
          $(".answer_box").show();
        }, 3000); 
      });
      console.log(divData)
});
  }
  $('.phaseOne input[type="radio"]').on('change', updateHref);

});
 

$(".prevFirst").click(function(){
  $(".first_question").show();
  var prevOption = $('input[name="use"]:checked').val();
  $('.toggle-button').attr('data-target', '#' + prevOption);
  $(".first_ans").hide();
  $(".second_question").hide();
});

$(".prevSecond").click(function(){
  $(".second_question").show();
  var prevOption = $('input[name="focus"]:checked').val();
  $('.toggle-button2').attr('data-target', '#' + prevOption);
});

$(".prevThird").click(function(){
  $(".second_question").show();
  var prevOption = $('input[name="focus2"]:checked').val();
  $('.toggle-button3').attr('data-target', '#' + prevOption);
  $(".third_question").hide();
});

$(".prevSubThird").click(function(){
  $(".third_question").show();
  var prevOption = $('input[name="focus2"]:checked').val();
  $('.toggle-button3').attr('data-target', '#' + prevOption);
  $(".third_sub_question").hide();
});
  
$(".prevFourth").click(function(){
  $(".third_question").show();
  var prevOption = $('input[name="function"]:checked').val();
  $('.toggle-button4').attr('data-target', '#' + prevOption);
  $(".fourth_question").hide();
});

$(".prevFifth").click(function(){
  $(".fourth_question").show();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button5').attr('data-target', '#' + prevOption);
  $(".fifth_question").hide();
});

$(".prevSixth").click(function(){
  $(".fifth_question").show();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button6').attr('data-target', '#' + prevOption);
  $(".answer_box").hide();
  $(".sixth_question").hide();
  $(".loading-overlay__spinner").hide();
  $("#targetDiv").hide();
  $(".toggle-button").css("opacity", "1");
});

$(".prevSeventh").click(function(){
  $(".sixth_question").show();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button7').attr('data-target', '#' + prevOption);
  $(".seventh_question").hide();
});

$(".prevEight").click(function(){
  $(".seventh_question").show();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button8').attr('data-target', '#' + prevOption);
  $(".eight_question").hide();
});

$(".prevNinth").click(function(){
  $(".eight_question").show();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button9').attr('data-target', '#' + prevOption);
  $(".ninth_question").hide();
});

$(".prevTenth").click(function(){
  $(".ninth_question").show();
  $(".loading-overlay__spinner").hide();
  $(".second_ans").hide();
  var prevOption = $('input[name="function2"]:checked').val();
  $('.toggle-button10').attr('data-target', '#' + prevOption);
  $(".tenth_question").hide();
  $(".toggle-button2").css("opacity", "1");
});


$(".continueSecond").click(function(){
  $(".first_question").hide();
  $(".second_question").show();
});
$(".continueThird").click(function(){
  $(".second_question").hide();
  $(".third_question").show();
});

$(".continueSubFourth").click(function(){
  $(".third_question").hide();
  $(".third_sub_question").show();
});
$(".continueFourth").click(function(){
  $(".third_sub_question").hide();
  $(".fourth_question").show();
});

$(".continueFifth").click(function(){
  $(".fourth_question").hide();
  $(".fifth_question").show();
   $("#countProductQuestion").empty();
});

$(".continueSixth").click(function(){
  $(".fifth_question").hide();
  $(".sixth_question").show();
  $(".answer_box").hide();
  $(".loading-overlay__spinner").hide();
});

$(".continueSeventh").click(function(){
  $(".sixth_question").hide();
  $(".seventh_question").show();
});

$(".continueEight").click(function(){
  $(".seventh_question").hide();
  $(".eight_question").show();
});

$(".continueNinth").click(function(){
  $(".eight_question").hide();
  $(".ninth_question").show();
  $(".loading-overlay__spinner").hide();
});


$(document).ready(function(){
  
  function updateHref2() {
      var values = [];
      $('.phaseTwo input[type="radio"]:checked').each(function() {
          var value = $(this).val();
          value = value.replace(/\s+/g, '+');
          values.push(value);
      });
      var href2 = 'https://gunnar.com/collections/shop-all?' + values.join('&');
  
        $('#dynamicLink2').attr('href', href2);
      $(".toggle-button2").click(function(){
        
        $(this).css("opacity", "0.85");
        $(".loading-overlay__spinner").show();
        var hrefValue2 = $("#dynamicLink2").attr("href");
        $.get(hrefValue2, function(data) {
        var divData = $(data).find("div.product_count").html();
          
        $("#countProductQuestion2").empty();
        setTimeout(function() { 
          $("#countProductQuestion2").append(divData);
        }, 1000); 

         $("#countProductQuestion2").empty();
        setTimeout(function() { 
          $('.ninth_question').hide();
          $(".second_ans").show();
        }, 2500); 
      });
      console.log(divData)
});
  }
  $('.phaseTwo input[type="radio"]').on('change', updateHref2);

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-section"] && !Shopify.designMode) return;
  try {
    
$('#testimonials_slider').owlCarousel({
	items: 1,
	loop:true,
	margin:0,
	nav:false,
	dots:true,
	autoplay: true,
	autoplayTimeout:8000,
	smartSpeed:800,
	navText:["<i class='fas fa-angle-left'></i>","<i class='fas fa-angle-right'></i>"],
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-section"] && !Shopify.designMode) return;
  try {
    
  $('#ugc_slider').owlCarousel({
    items: 1,
    loop: true,
    margin: 15,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 8000,
    smartSpeed: 800,
    navText: ["<i class='fas fa-angle-left'></i>", "<i class='fas fa-angle-right'></i>"],
    responsiveClass: true,
    responsive: {
      300: {
        items: 1,
        stagePadding:45
      },
      576: {
        items: 2,
        stagePadding:0,
      },
      768: {
        items: 4,
      },
    },
  });

  } catch(e) { console.error(e); }
})();
})();
